import React, { ReactNode } from "react";
import { getMorningAndEveningCelebrations } from "./calendar/ordinariate-calendar";

const Row: React.FC<{ label: string; children: ReactNode }> = (props) => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                gap: 8,
                paddingLeft: 16,
            }}
        >
            <div style={{ minWidth: 80, fontWeight: "bold" }}>
                {props.label}
            </div>
            <div style={{ fontSize: "85%" }}>
                {props.children === "MISSING" ? (
                    <span style={{ backgroundColor: "#F99" }}>MISSING</span>
                ) : (
                    props.children
                )}
            </div>
        </div>
    );
};

export const PublicOrdo: React.FC<{}> = () => {
    const isEpiphanyTransferred = true;
    const isAscensionTransferred = false;
    const isCorpusChristiTransferred = true;

    const regionLabels =
        localStorage.getItem("region-switches")?.split(";;;") ?? [];

    const year = getMorningAndEveningCelebrations(
        new Date().getFullYear(),
        isEpiphanyTransferred,
        isAscensionTransferred,
        isCorpusChristiTransferred,
        regionLabels
    ).slice(365);

    return (
        <>
            {year.map((liturgicalDay, dayIndex) => {
                const prevLiturgicalDay = year[dayIndex - 1];

                return (
                    <>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                borderBottom: "1px solid silver",
                            }}
                        >
                            <div
                                style={{
                                    width: 60,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    flexShrink: 0,
                                }}
                            >
                                <div
                                    style={{
                                        fontWeight: "bold",
                                        paddingTop: 8,
                                    }}
                                >
                                    {[
                                        "",
                                        "January",
                                        "February",
                                        "March",
                                        "April",
                                        "May",
                                        "June",
                                        "July",
                                        "August",
                                        "September",
                                        "October",
                                        "November",
                                        "December",
                                    ][liturgicalDay.month].slice(0, 3)}{" "}
                                    {liturgicalDay.date}
                                </div>
                            </div>
                            <div
                                style={{
                                    flexGrow: 1,
                                    padding: 8,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 8,
                                }}
                            >
                                {liturgicalDay.morningOptions.map((option) => {
                                    return (
                                        <div style={{ fontSize: "110%" }}>
                                            {option.regionNote ? (
                                                option.regionNote + ": "
                                            ) : (
                                                <></>
                                            )}
                                            <span
                                                style={{
                                                    fontWeight:
                                                        option.rank <= 8
                                                            ? "bold"
                                                            : undefined,
                                                    fontStyle: option.optional
                                                        ? "italic"
                                                        : undefined,
                                                }}
                                            >
                                                {option.rank <= 8
                                                    ? option.title.toLocaleUpperCase()
                                                    : option.title}
                                            </span>{" "}
                                            (
                                            {option.optional ? "optional " : ""}
                                            {option.type})
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </>
                );
            })}
        </>
    );
};
